import { Col, Row } from 'react-bootstrap';
import FeelingResult from '../../Dashboard/components/FeelingResult';
import CommentsByFeelingsGrafic from '../components/CommentsByFeelingsGrafic';
import CommentsDetail from '../components/CommentsDetail';
import { useFeelings } from '../api/getFeelings';
import SpinerLoader from '../../../components/SpinerLoader';
import NoData from '../../../components/NoData';
import { useOutletContext } from "react-router-dom";
import type { DashboardOutletContext } from "../../../components/Layouts/GlobalDashboardLayout";

export default function FeelingAnalysis() {
    const { data: feelings, isLoading } = useFeelings();
    const { section1Ref, section2Ref, section3Ref } = useOutletContext<DashboardOutletContext>();

  return (
    <>
      {isLoading ?
        <SpinerLoader />
        :
        feelings ?
                  <Row>
                      <Col md={4}>
                          <div ref={section1Ref} className="dashboard-section">
                              <FeelingResult
                                  totalAvg={feelings.totalAvg}
                                  totalSurveys={feelings.totalSurveys}
                              />
                          </div>
                      </Col>

                      <Col md={8}>
                          <div ref={section2Ref}>
                              <CommentsByFeelingsGrafic
                                  commentsByFeelings={feelings.commentsByFeelings}
                              />
                          </div>
                      </Col>

                      <Col className="mt-3">
                          <div ref={section3Ref}>
                              <CommentsDetail feelings={feelings} />
                          </div>
                      </Col>
                  </Row>
          : <NoData />
      }
    </>
  );

}